import { z } from 'zod';

export const LOGIN_ERROR_REASONS = {
  expired: 'expired',
  already_used: 'already_used',
  invalid: 'invalid',
  session_expired: 'session_expired',
} as const;

export const loginErrorReasonResponseSchema = z.enum(LOGIN_ERROR_REASONS);
export type LoginErrorReasonResponse = z.infer<typeof loginErrorReasonResponseSchema>;
